import type { FaireProductEntity } from "../../entity_types/product";

export const p_t8u3cmmhga: FaireProductEntity = {
  token: "p_t8u3cmmhga",
  type: "product",
  name: "Elderberry Liquid Drops with Vitamin C for Immune Support",
  brandToken: "b_u4qayfrgch",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/37a991db4b4750bb3240508fbd67e1f67cf23d8f4777c852cd703db6a596f245.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7eafc416d42f185286c2873ceea445ade0b106bc3cd1353a1390cd526c7d6d4.png",
    "https://cdn.faire.com/fastly/ca27460adaec0bfc3d22e41718f2e4db80167a5d551ed3f3646e64daf06da35e.jpeg",
    "https://cdn.faire.com/fastly/7275f6f9bc0b8d35d54f4083329b951be17d9d8dd2e0cab92034a6396b4fafd0.png",
    "https://cdn.faire.com/fastly/8203b23f45a4a2b1ea2034ee8bd58f7136f25e66176befedb1cf4f63b84458a3.jpeg",
    "https://cdn.faire.com/fastly/84688252c55745351c0b8d59565eb000fbe46887867e9552ff93d644a331c530.jpeg",
    "https://cdn.faire.com/fastly/716e5bcd1d446eff288fd5f2d0009eb449b4a878cb9da649836249566d61d4b9.jpeg",
    "https://cdn.faire.com/fastly/faad921c9fac81e9ab3062ff49498b369681a84ee3187d3b1657e678f7f9626a.jpeg",
  ],
  priceDollars: 18.7,
  description:
    "Black elderberry (Sambucus nigra L.) is a fruit derived from the black elder plant used for centuries to help reduce upper respiratory symptoms and to assist in shortening the duration of cold and flu symptoms. Our elderberry drops come with 25 mg of vitamin C from acerola cherry fruit for an extra boost of immune support and are made from the highest quality organic elder trees. They have a great tasting natural flavor derived from Concord grapes. \n\nOur elderberry drops do not contain any sugar, salt, starch, wheat,  gluten, yeast, milk, soy derivatives or artificial preservatives.\n\nTASTES LIKE: Tart and sweet Concord grapes\n\nINGREDIENTS: Vitamin C (From Acerola Cherry Fruit Extract), Organic Black Elderberry Extract, Vegetable Glycerin, Purified Water, Natural Flavor\n\nPERFECT FOR: Adding to a calming tea with lemon and honey for the perfect immune-boosting drink",
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:33.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
